import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromFileExport from './file-export.reducer';
import { EntityState } from '@ngrx/entity';
import { FileExportDomain } from '@mode/shared/contract-common';

export const selectFileExportState = createFeatureSelector<EntityState<FileExportDomain.FileExport>>(
  fromFileExport.fileExportFeatureKey
);

const { selectAll, selectEntities, selectIds, selectTotal } =
  fromFileExport.adapter.getSelectors(selectFileExportState);

export function createExportSelector(id: string) {
  return createSelector(selectEntities, (entities) => entities[id]);
}

export function createLatestChartExportSelector(chartToken: string) {
  return createSelector(selectAll, (exports) => {
    return exports.find(
      (job) => job.type === FileExportDomain.ExportType.Chart && job.vizToken === chartToken
    ) as FileExportDomain.ChartExport;
  });
}

export const selectExportStatusByVizToken = createSelector(selectAll, (exports) => {
  return exports.reduce(
    (acc, next) => {
      if (next.type === FileExportDomain.ExportType.Chart && next.vizToken) {
        acc[next.vizToken] = next.status;
      }

      return acc;
    },
    {} as { [vizToken: string]: FileExportDomain.ExportStatus }
  );
});

export { selectTotal, selectAll, selectEntities };
